import "izitoast/dist/css/iziToast.min.css";
import iZtoast from "izitoast";

const toast = {
  error: (message: string, title = "Error"): void => {
    return iZtoast.error({
      title,
      message,
      position: "bottomCenter",
    });
  },
  warning: (message: string, title = "Warning"): void => {
    return iZtoast.warning({
      title,
      message,
      position: "bottomCenter",
    });
  },
  success: (message: string, title = "Success"): void => {
    return iZtoast.success({
      title,
      message,
      position: "bottomCenter",
    });
  },
};

export default toast;
